import Script from "next/script";
import { useContext } from "react";
import { bpInRange, BreakpointContext } from "@/context/BreakpointContext";
import { CalendlyStoryblok } from "@/types/component-types-sb";

interface Props {
  blok: CalendlyStoryblok;
}

const Calendly = (props: Props) => {
  const {
    blok: { desktop_height = 900, mobile_height = 900, calendly_url = "" },
  } = props;
  const { currentBp } = useContext(BreakpointContext);
  const smallViewport = bpInRange({ currentBp, bp: "m", range: "down" });

  return (
    <>
      <Script
        strategy={"lazyOnload"}
        src="https://assets.calendly.com/assets/external/widget.js"
      />
      <div
        className="calendly-inline-widget"
        data-url={calendly_url}
        style={{
          width: "100%",
          minWidth: "320px",
          height: smallViewport ? `${mobile_height}px` : `${desktop_height}px`,
          maxWidth: "100%",
        }}
      />
    </>
  );
};

export default Calendly;
